import { ColoursObj, Icon, Typography, useSnackListStore } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useGetChatName } from "../hooks/useGetChatName";
import { useRocketChatContext } from "../rocketChatProvider";
import { useLocation } from "react-router-dom";
import { routes } from "routing";

interface IRocketSnackProps {
  messageContents: any;
  uId: number;
}

export const RocketSnack = ({ messageContents, uId }: IRocketSnackProps) => {
  const location = useLocation();
  const { openChat } = useRocketChatContext();
  const snackListStore = useSnackListStore.getState();
  const chatName = useGetChatName(messageContents?.payload?.rid ?? "");

  if (location.pathname.includes(messageContents?.payload?.rid) || location.pathname.includes(routes.chat.list.path)) {
    return <div />;
  }

  return (
    <Stack
      style={{
        width: "calc(var(--app-width) - 48px)",
        padding: "8px 16px",
        margin: "4px 16px",
        backgroundColor: ColoursObj.backgrounds.card,
        borderRadius: "8px",
        boxShadow: "0px 0px 3px " + ColoursObj.shades.shade0,
        display: "flex",
        flexDirection: "row",
        boxSizing: "border-box",
      }}
    >
      <Stack
        style={{
          width: "calc(100% - 24px)",
        }}
        onClick={() => {
          openChat(messageContents?.payload?.rid, messageContents?.payload?.type);
          snackListStore.removeSnackFromList(uId);
        }}
      >
        <Typography variant="bodyBold">{chatName ?? messageContents?.title}</Typography>
        <Typography
          style={{
            width: "100%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {messageContents?.text}
        </Typography>
      </Stack>
      <Stack style={{ justifyContent: "center" }} onClick={() => snackListStore.removeSnackFromList(uId)}>
        <Icon name="Exit" />
      </Stack>
    </Stack>
  );
};
